import { GET_REST_SETTING } from '../../axios/appiendPoints';
import { axiosInstance } from '../../axios/axios';
import {
  FETCH_REST_SETTING_FAILURE,
  FETCH_REST_SETTING_REQUEST,
  FETCH_REST_SETTING_SUCCESS,
  RESET_STORES,
} from './restSettingTypes';
import { setLocalItem } from '../../webStorage/localStorage';
export const fetchRestSettingRequest = () => {
  return {
    type: FETCH_REST_SETTING_REQUEST,
  };
};

export const fetchRestSettingSuccess = (setting) => {
  return {
    type: FETCH_REST_SETTING_SUCCESS,
    payload: setting,
  };
};

export const fetchRestSettingFailure = (error) => {
  return {
    type: FETCH_REST_SETTING_FAILURE,
    payload: error,
  };
};
export const resetRestSetting = () => ({ type: RESET_STORES });
// Fetching Rest Setting From nameId
export const fetchRestSetting = (id) => {
  let restSettingParams = new URLSearchParams();
  restSettingParams.append('nameid', id?.toLowerCase());
  return (dispatch) => {
    dispatch(fetchRestSettingRequest());
    axiosInstance
      .post(GET_REST_SETTING, restSettingParams)
      .then((response) => {
        const setting = response.data.data;
        // setCookie('rest_id', response.data?.data?.id);
        // setCookie('curr_code', response.data?.data?.curr_code);
        localStorage.setItem('curr_code', response.data?.data?.curr_code);
        const user_app_paycash_text = response?.data?.data?.user_app_paycash_text || '';
        setLocalItem('user_app_paycash_text', user_app_paycash_text);
        dispatch(fetchRestSettingSuccess(setting));
      })
      .catch((err) => {
        dispatch(fetchRestSettingFailure(err.message));
      });
  };
};
